import React, {useContext} from "react"
import {Image, Text, View} from "@react-pdf/renderer"
import {baseStyles} from "../styles"
import {PDFContext} from "../BasePDF"
import {isSafeLogoUrl} from "../../../../utils/companyLogo"
import TRUEDESKING_LOGO from "../../../../assets/images/truedesking-footer-logo.png"

// Thin gray strip at the bottom of the page: "Powered by" + the
// TrueDesking logo, left-aligned.
//
// `showCompanyLogo` additionally centers the account's own logo on its own row
// just above that strip. It stays an explicit per-document opt-in because the
// row adds ~30pt of height and the worksheets are single-page (wrap={false}), so
// whether a document can afford it is a per-document fact. The TrueDesking
// attribution is never replaced or moved by it.
export const FooterPDF = ({showCompanyLogo}) => {
    const pdfData = useContext(PDFContext)
    if (!pdfData) return null

    const {companyLogoUrl} = pdfData
    const hasCompanyLogo = Boolean(showCompanyLogo) && isSafeLogoUrl(companyLogoUrl)

    return (
        <View>
            {
                hasCompanyLogo &&
                <View style={baseStyles.footerCompanyRow}>
                    <Image style={baseStyles.footerCompanyLogo} src={companyLogoUrl}/>
                </View>
            }
            <View style={baseStyles.pageFooter}>
                <View style={baseStyles.footerLeft}>
                    <Text style={baseStyles.footerText}>Powered by</Text>
                    <Image style={baseStyles.footerLogo} src={TRUEDESKING_LOGO}/>
                </View>
            </View>
        </View>
    )
}
